/* eslint-disable @typescript-eslint/no-explicit-any */
import { Select as AntSelect } from "antd";
import React, { type JSX } from "react";
import styled from "styled-components";
import Text from "../Text/Text";
import { CaretDownOutlined } from "@ant-design/icons";
import color from "../../resource/color";
const { Option } = AntSelect;
interface Props {
  data: {
    key: any;
    value?: any;
    label?: string | JSX.Element;
  }[];
  onChange?: (v: any) => void;
  setValue?: (value: any) => void;
  style?: React.CSSProperties;
  defaultValue?: string | number;
  value?: string | number | string[];
  disabled?: boolean;
  edit?: boolean;
  placeholder?: string;
  labelInValue?: boolean;
  onSearch?: (value: string) => void;
  filterOption?: boolean;
  notFoundContent?: JSX.Element | null;
  mode?: "multiple" | "tags" | undefined;
  allowClear?: boolean;
  showArrow?: boolean;
  maxTagCount?: number | "responsive";
  fontWeight?: any;
  fontSize?:
    | 12
    | 13
    | 14
    | 16
    | 18
    | 20
    | 22
    | 24
    | 26
    | 28
    | 30
    | 32
    | 34
    | 36
    | 38
    | 40
    | 46
    | 50;
}

export const AntSelectCustom = styled(AntSelect)<{
  $fontSize?: number | string;
}>`
  .ant-select-selector {
    height: 100% !important;
    min-height: 40px !important;
    display: flex;
    align-items: center;
    font-family: Sarabun !important;

    ${({ $fontSize }) =>
      $fontSize !== undefined
        ? `font-size: ${typeof $fontSize === "number" ? `${$fontSize}px` : $fontSize} !important;`
        : ""}
  }

  .ant-select-selection-placeholder {
    font-family: Sarabun !important;
  }

  .ant-select-selection-item {
    border-radius: 4px;
    font-family: Sarabun !important;
    font-weight: 600 !important;
    display: flex;
    align-items: center;
    color: #000000;
  }

  .ant-select-selection-wrap {
    align-self: center !important;
  }

  .ant-select-arrow {
    pointer-events: auto !important;
  }
`;

function Select({
  data = [],
  onChange,
  setValue,
  defaultValue,
  value,
  disabled = false,
  placeholder = "กรุณาเลือก",
  mode,
  style,
  allowClear = true,
  fontWeight = 600,
  fontSize,
  ...props
}: Props): JSX.Element {
  const [open, setOpen] = React.useState(false);
  const selectRef = React.useRef<any>(null);

  const handleIconClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (disabled) return;

    selectRef.current?.focus();
    setOpen(true);
  };

  return (
    <AntSelectCustom
      ref={selectRef}
      {...props}
      $fontSize={fontSize}
      open={open}
      onOpenChange={setOpen}
      dropdownStyle={{ fontFamily: "Sarabun" }}
      onChange={(e) => {
        onChange?.(e);
        setValue?.(e);
      }}
      allowClear={allowClear}
      style={{ ...style, width: "100%" }}
      placeholder={placeholder}
      suffixIcon={
        <CaretDownOutlined
          onMouseDown={handleIconClick}
          style={{
            color: color.Text1,
            fontSize: "20px",
            cursor: disabled ? "not-allowed" : "pointer",
            paddingTop: mode !== "multiple" ? "45%" : 0,
          }}
        />
      }
      value={value}
      defaultValue={defaultValue}
      disabled={disabled}
      mode={mode}
    >
      {data.map((item) => (
        <Option key={item.key} value={item.value ? item.value : item.key}>
          <Text fontFamily='Sarabun' fontWeight={fontWeight || 600} fontSize={fontSize || 14}>
            {item.label}
          </Text>
        </Option>
      ))}
    </AntSelectCustom>
  );
}

export default Select;
